const t = null;
export {
  t as default
};
//# sourceMappingURL=index.es147.js.map
